import Block from '../../../components/Block/Block';
import MediaCard from '../../../components/MediaCard/MediaCard';
import FadeIn from '../../../components/FadeIn/FadeIn';
import PaginationControl from '../../../components/PaginationControl/PaginationControl';
import style from './gymblock.module.scss';
import { useState } from 'react';

const GymBlock = ({ facility }) => {
    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = 3; // Items per page
    
    if (!facility || !facility.facility_medias || facility.facility_medias.length === 0) {
        return null;
    }

    // Filter out any media items without images and map to required format
    const mediaWithImages = facility.facility_medias
        .filter(media => media.Image?.url)
        .map(media => ({
            id: media.id,
            url: media.Image.url,
            name: `Фото зала ${facility.Name}`
        }));

    // Calculate pagination
    const totalItems = mediaWithImages.length;
    const pageCount = Math.ceil(totalItems / pageSize);
    const paginatedItems = mediaWithImages.slice(
        (currentPage - 1) * pageSize,
        currentPage * pageSize
    );

    return (
        <Block
            flexDirection='column'
            justifyContent='center'
            alignItems='start'
            width="75%"
            height='fit-content'
            background="rgba(255, 255, 255, 0.85)"
            header='НАШИ ЗАЛЫ'
        >
            <FadeIn>
                <div className={style.gridContainer}>
                    {paginatedItems.map(media => (
                        <div key={media.id} className={style.gridItem}>
                            <MediaCard
                                media={`${process.env.REACT_APP_STRAPI_URL}${media.url}`}
                                title={media.name}
                                width="90%"
                            />
                        </div>
                    ))}
                </div>
                
                {pageCount > 1 && (
                    <PaginationControl
                        page={currentPage}
                        setPage={setCurrentPage}
                        pageCount={pageCount}
                    />
                )}
            </FadeIn>
        </Block>
    );
};

export default GymBlock;